let origin = 'api.monadsearch.com'
let protocol = 'https'

const getFlagUrl = (code, size) => {
  let url = ''
  try {
    url = `${protocol}://${origin}/storage/country/flags/${size}x${size}/${code ? code.toLowerCase() : ''}.png`
  } catch (error) { url = '' }
  return url
}

const config = {
  forceProductionApi: false,
  apiUrl: `${protocol}://${origin}/api/`,
  storageUrl: `${protocol}://${origin}/storage/`,
  resources: {
    country: {
      flag: {
        '16': (code) => getFlagUrl(code, 16),
        '24': (code) => getFlagUrl(code, 24),
        '32': (code) => getFlagUrl(code, 32),
        '48': (code) => getFlagUrl(code, 48),
        '64': (code) => getFlagUrl(code, 64),
        '128': (code) => getFlagUrl(code, 128)
      }
    }
  }
}
export { config }
export default config